export default "__VITE_ASSET__Cs_eEMbM__"